export enum TokenValidationErrorsEnum {
    SHOULD_NOT_BE_EMPTY = 'Token should not be empty',
    SHOULD_BE_A_STRING = 'Token must be a string',
    SHOULD_BE_ALPHANUMERIC = 'Token must match alphanumeric pattern',
}
